<template>
  <form
    id="stripe_payment_form"
    action=""
    method="post"
    :allFormProps="allFormProps"
    :allCharges="allCharges"
  >
    <div class="payment_container">
      <div class="payment_summary">
        <h2>Order Summary</h2>
        <h6>Registration: 1 team <span>$500</span></h6>
        <h5>
          Total <span>${{ total_charges }}</span>
        </h5>
      </div>
      <h6 class="sponsorship_info">{{ sponsorship }}</h6>
      <h2>Payment Method</h2>
      <label for="card-element">
        <h5>Credit or debit card</h5>
      </label>
      <div id="card-element" ref="card">
        <!-- A Stripe Element will be inserted here. -->
      </div>
      <!-- Used to display Element errors. -->
      <div id="card-errors" role="alert" />
    </div>
    <button @click="purchase">
      Purchase
    </button>
  </form>
</template>

<script>
import axios from "axios";
import qs from "qs";
import EventBus from "../event_bus";
import xss from "xss"; // only set this up if data looks corrupted

export default {
  name: "StripePayment",
  props: {
    allFormProps: Object,
    allCharges: Object,
  },
  data() {
    return {
      stripe: Stripe("pk_live_4fn75E37OX6rPXo9RFxryo3v00V9kG95DS"),
      // stripe: Stripe('pk_test_jFBf7DhYb6NRzGeJT7mudNd300fV3IXFIZ'),
      elements: "",
      card: "",
      wordpress: {
        ajax: "",
        nonce: "",
      },
      stripe_token: "",
    };
  },

  computed: {
    total_charges() {
      var total = this.allCharges.team_registration
        ? this.allCharges.team_registration
        : 0;
      return total;
    },
    sponsorship() {
      if (
        this.allFormProps.gold_sponsor ||
        this.allFormProps.silver_sponsor ||
        this.allFormProps.platinum_sponsor
      ) {
        return "Someone will be getting in touch you with to discuss further details about sponsorship.";
      } else {
        return "";
      }
    },
  },
  mounted: function() {
    this.elements = this.stripe.elements();
    this.card = this.elements.create("card");
    this.card.mount(this.$refs.card);

    // only if wordpress ajax data is present set props
    if (window.biscayne_legends_ajax) {
      this.wordpress.ajax = biscayne_legends_ajax.ajaxurl
        ? biscayne_legends_ajax.ajaxurl
        : "";
      this.wordpress.nonce = biscayne_legends_ajax.nonce
        ? biscayne_legends_ajax.nonce
        : "";
    }
  },
  methods: {
    checkForm: function(e) {
      console.log("if form checked");
      e.preventDefault();
    },

    processStripe: function(e) {
      document.querySelector(".stripe_processing").style.display = "block";

      var data = {
        action: "legends_registration_process_form",
        security: this.wordpress.nonce,
        stripeToken: this.stripe_token,
        totalCharges: this.total_charges,
        formData: this.allFormProps,
      };

      axios
        .post(this.wordpress.ajax, qs.stringify(data))
        .then(function(response) {
          console.log("success", data);
          document.querySelector(".stripe_processing").style.display = "none";
          document.querySelector(".registration_form_success").style.display =
            "block";
          document.querySelector(".payment").style.display = "none";
          // currentObj.output = response.data;
        })
        .catch(function(error) {
          console.log("error", error);
          document.querySelector(".stripe_processing").style.display = "none";
          document.querySelector(".registration_form_failure").style.display =
            "block";
          document.querySelector(".payment").style.display = "none";
          // currentObj.output = error;
        });
    },

    purchase: function() {
      event.preventDefault();

      var self = this;

      this.stripe.createToken(this.card).then(function(result) {
        if (result.error) {
          console.log("error");
          self.hasCardErrors = true;
          // var errorElement = document.getElementById('card-errors');
          // errorElement.textContent = result.error.message;

          return;

          // var errorElement = document.getElementById('card-errors');
          // errorElement.textContent = result.error.message;
        } else {
          // console.log('no error trying to purchase')
          self.stripe_token = result.token.id;
          self.processStripe();
        }
      });
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* --- hlm registration forms --- */

* {
  box-sizing: border-box;
}

button,
input[type="button"],
input[type="reset"],
input[type="submit"] {
  padding: 0.6em 1em 0.4em;
  border: 1px solid;
  border-color: #ccc #ccc #bbb;
  border-radius: 3px;
  background: #e6e6e6;
  color: rgba(0, 0, 0, 0.8);
  line-height: 1;
  font-size: 12px;
  font-size: 0.75rem;
}

button:hover,
input[type="button"]:hover,
input[type="reset"]:hover,
input[type="submit"]:hover {
  border-color: #ccc #bbb #aaa;
}

button:active,
button:focus,
input[type="button"]:active,
input[type="button"]:focus,
input[type="reset"]:active,
input[type="reset"]:focus,
input[type="submit"]:active,
input[type="submit"]:focus {
  border-color: #aaa #bbb #bbb;
}

a {
  text-decoration: none;
}

input[type="text"],
input[type="email"],
input[type="url"],
input[type="password"],
input[type="range"],
input[type="date"],
input[type="month"],
input[type="week"],
input[type="time"],
input[type="datetime"],
input[type="datetime-local"],
input[type="color"],
textarea {
  border: 2px solid #ededed !important;
  border-radius: 0px;
  color: #555;
  margin: 0 0 5px 0;
  font-size: 14px !important;
  padding: 10px !important;
  font-family: "Open Sans", sans-serif;
}

input[type="text"]:focus,
input[type="email"]:focus,
input[type="url"]:focus,
input[type="password"]:focus,
input[type="search"]:focus,
input[type="number"]:focus,
input[type="number"]:focus,
input[type="range"]:focus,
input[type="date"]:focus,
input[type="month"]:focus,
input[type="week"]:focus,
input[type="time"]:focus,
input[type="datetime"]:focus,
input[type="datetime-local"]:focus,
input[type="color"]:focus,
textarea:focus {
  background-color: #ededed !important;
}

select {
  margin: 0;
  display: block;
  width: 100px;
  padding: 0.5rem 0.75rem !important;
  font-size: 14px;
  line-height: 1.25;
  color: #464a4c;
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 2px solid #cccccc !important;
  border-radius: 100px;
  box-shadow: none !important;
  touch-action: manipulation;
}

select:not([size]):not([multiple]) {
  height: calc(2.25rem + 2px);
}

label {
  display: inline-block;
  margin: 5px 0 5px 3px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 700;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  line-height: 24px;
  text-align: left;
}

input {
  display: block;
  margin: 0px 0;
  padding-right: 10px;
  padding-left: 10px;
  width: 100%;
  border-color: #fff;
  background-color: #fff;
  /*background-color: #eaeaea;*/
  color: #000;
  letter-spacing: 1px;
  font-weight: 200;
  font-size: 12px;
  font-family: Lovelo, sans-serif;
  line-height: 30px;
}

label {
  width: calc(100% - 20px);
  color: #444;
}

.payment_container {
  padding: 0 30px;
  /* background: lightgrey; */
}

button {
  display: inline-block;
  margin-top: 20px;
  margin-right: 30px;
  float: right;
  padding: 16px 55px !important;
  width: auto;
  border: 2px #ec1c24 solid;
  border-radius: 0px;
  background-color: #ec1c24;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 700;
  font-size: 16px;
  font-family: Lovelo, sans-serif;
  line-height: 24px;
}

h2 {
  color: #444;
  letter-spacing: 0px;
  font-weight: normal;
  font-smoothing: antialiased;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 24px;
  padding: 10px 0;
  margin: 0px;
}

h5 {
  color: #444;
  letter-spacing: 0px;
  font-weight: normal;
  font-smoothing: antialiased;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  line-height: 17px;
  font-weight: 600;
  padding: 10px 0 0 0;
  margin: 0px;
}

h6 {
  color: #444;
  letter-spacing: 0px;
  font-weight: normal;
  font-smoothing: antialiased;
  font-family: "Open Sans", sans-serif;
  line-height: 21px;
  font-size: 14px;
  font-weight: 400;
  padding: 0px 0;
  margin: 0px;
}

.payment_summary {
  max-width: 450px;
  margin: 0 0 0px 0;
}

.payment_summary span {
  float: right;
}

.sponsorship_info {
  margin: 10px 0 35px;
  line-height: 17px;
  font-size: 14px;
}

/**
 * The CSS shown here will not be introduced in the Quickstart guide, but shows
 * how you can use CSS to style your Element's container.
 */
.StripeElement {
  box-sizing: border-box;
  transition: box-shadow 150ms ease;

  border: 2px solid #ededed !important;
  border-radius: 0px;
  color: #555;
  margin: 0 0 5px 0;
  font-size: 14px !important;
  padding: 20px !important;
  font-family: "Open Sans", sans-serif;
  line-height: 30px;

  display: block;
  width: 100%;
  border-color: #cacaca;
  background-color: #fff;
  letter-spacing: 1px;
  font-weight: 200;
  line-height: 30px;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
